/**
 * お気に入り登録ボタン
 */

// import global variables.
import {getStorageItem, setStorageItem} from '../utils/global';

const favoriteTypeName = {
    product: '商品',
    work: '作品',
    artist: '声優・アーティスト'
};


/**
 * updateStorageItem - ローカルストレージを更新
 * @param  {String}  type     ストレージに追加するidの種類（product|work|artist）
 * @param  {String}  targetId ストレージに追加するid名
 * @param  {Boolean} isAdd    追加する(true)か、削除する(false)か
 * @return {Boolean}          更新があったか否か
 */
const updateStorageItem = (type, targetId, isAdd) => {
    const favoriteData = JSON.parse(getStorageItem('favorite')) || {};
    const hasTypeProperty = favoriteData.hasOwnProperty(type);

    // ストレージから削除する場合
    if (!isAdd) {
        // ローカルストレージに削除するキー名が無い場合、何もせず終了
        if (!hasTypeProperty) {
            return false;
        }

        // 対象のid名を削除
        favoriteData[type].splice(favoriteData[type].indexOf(targetId), 1);
    } else {
        // ローカルストレージに追加するキー名が無い場合、空の配列を作成
        if (!hasTypeProperty) {
            favoriteData[type] = [];
        }

        // 許容量を超えた場合、お気に入りを解除しないと追加できませんよというアラートを表示
        if (favoriteData[type].length >= 100) {
            // eslint-disable-next-line no-alert
            if (window.confirm(`${favoriteTypeName[type]}のお気に入りは100件しか登録できません。\n登録済のお気に入りを削除しますか？`)) {
                // confirmダイアログの「OK」がクリックされた場合、別タブでお気に入り一覧ページへ遷移
                window.open('/favorite/', '_blank');
            }

            // 追加は不可のためここで終了
            return false;
        }

        // id名を追加
        favoriteData[type].unshift(targetId);
    }

    // ローカルストレージを更新
    return setStorageItem('favorite', JSON.stringify(favoriteData));
};

/**
 * updateButtonState - お気に入りボタンの状態を更新
 * @param  {String}  targetId 対象のid名
 * @param  {Boolean} isAdd    追加されているか否か
 * @return {Void}
 */
const updateButtonState = (targetId, isAdd) => {
    // id名が未指定または空文字の場合は何もしない
    if (!targetId) {
        return;
    }

    const hasSameIdButtons = document.querySelectorAll(`.c-button-favorite[data-id="${targetId}"]`);

    // 同じid名を持つボタンをすべて更新
    for (const button of hasSameIdButtons) {
        button.classList[isAdd ? 'add' : 'remove']('is-favorite');
        button.setAttribute('aria-pressed', `${isAdd}`);
    }
};

/**
 * updateAllButtonState - すべてのボタンの状態を更新
 * @param  {[type]} buttons [description]
 * @return {[type]}         [description]
 */
export const updateAllButtonState = (buttons) => {
    const favoriteData = JSON.parse(getStorageItem('favorite')) || {};

    for (const button of buttons) {
        const {id} = button.dataset;
        let isFavorite = false;

        for (const type of Object.keys(favoriteData)) {
            // お気に入りに追加されているか検証
            if (favoriteData[type].includes(id)) {
                isFavorite = true;
                updateButtonState(id, true);

                break;
            }
        }

        button.setAttribute('aria-pressed', `${isFavorite}`);
    }
};

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    const favoriteData = JSON.parse(getStorageItem('favorite')) || {};

    // ローカルストレージが空の場合、初期化を実行
    if (!Object.keys(favoriteData).length) {
        setStorageItem('favorite', JSON.stringify({
            product: [],
            work: [],
            artist: []
        }));
    }

    // お気に入りに追加ボタンの状態を更新
    updateAllButtonState(document.querySelectorAll('.c-button-favorite[data-id]'));

    // お気に入りに追加ボタンにクリックイベントを実装
    document.addEventListener('click', (event) => {
        const {target} = event;

        // お気に入りに追加ボタン出ない場合は何もしない
        if (!target.classList.contains('c-button-favorite')) {
            return;
        }

        const {type, id} = target.dataset;
        const isAdded = target.classList.contains('is-favorite');

        // ローカルストレージを更新
        if (updateStorageItem(type, id, !isAdded)) {
            // ストレージに更新があった場合、ボタンの状態を更新
            updateButtonState(id, !isAdded);
        }
    });
};
